import React, { FunctionComponent, SVGProps } from 'react';

import { Trans, TransProps, useTranslation } from 'react-i18next';

import { IModalButton } from '../../interfaces/button';
import { ITagProps } from '../../interfaces/global';
import { BreadcrumbItemProps } from '../Breadcrumbs/BreadcrumbItem/BreadcrumbItem';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import PageCurvedContainer from '../PageCurvedContainer/PageCurvedContainer';
import StyledButtonNE from '../StyledButtonNE/StyledButtonNE';
import Tag from '../Tag/Tag';

export interface GenericPageNEProps {
  breadcrumbs: BreadcrumbItemProps[];
  ImageComponent?: FunctionComponent<SVGProps<SVGSVGElement> & { title?: string }>;
  imageSrc?: string;
  title: string | TransProps<any>;
  description: string | TransProps<any>;
  primaryButton: IModalButton;
  secondaryButton?: IModalButton;
  tag?: ITagProps;
  loading?: boolean;
}

const GenericPageNE = ({
  breadcrumbs,
  ImageComponent,
  imageSrc,
  title,
  description,
  primaryButton,
  secondaryButton,
  tag,
  loading
}: GenericPageNEProps) => {
  const { t } = useTranslation();

  return (
    <div className="page-container curved" data-experience="new">
      <div className="page-content-container">
        <Breadcrumbs items={breadcrumbs} />
      </div>
      <PageCurvedContainer verticalAlignment="center">
        <div className="flex flex-column items-center justify-center h-100 gap-6 text-center">
          <div className="ne-genpage-image-container">
            {ImageComponent && <ImageComponent width={213} height={213} />}
            {imageSrc && <img src={imageSrc} alt="Buddy image" />}
          </div>
          <div className="flex flex-column gap-4">
            {tag && (
              <div className="self-center">
                <Tag {...tag} />{' '}
              </div>
            )}
            <div className="ne-font-heading-md">
              {typeof title === 'string' ? t(title) : <Trans {...title}></Trans>}
            </div>
            <div className="ne-font-body-sm">
              {typeof description === 'string' ? t(description) : <Trans {...description}></Trans>}
            </div>
          </div>
          <div className="flex flex-column items-center gap-6">
            {primaryButton && (
              <div className="w-fit">
                <StyledButtonNE
                  buttonType={'primary'}
                  buttonSize="lg"
                  action={primaryButton.action}
                  classes={primaryButton.classes}
                  loading={loading}
                >
                  {t(primaryButton.text)}
                </StyledButtonNE>
              </div>
            )}
            {secondaryButton && (
              <div className="ne-font-link-lg w-fit">
                <StyledButtonNE
                  action={secondaryButton.action}
                  buttonType="tertiary"
                  buttonSize="lg"
                  classes={secondaryButton.classes}
                  disabled={loading}
                >
                  {t(secondaryButton.text)}
                </StyledButtonNE>
              </div>
            )}
          </div>
        </div>
      </PageCurvedContainer>
    </div>
  );
};

export default GenericPageNE;
